__turbopack_context__.v({
  "hamburger": "mobile-module__BcsPoG__hamburger",
  "hamburgerDarkBg": "mobile-module__BcsPoG__hamburgerDarkBg",
  "menuItem": "mobile-module__BcsPoG__menuItem",
  "mobileNavDropdown": "mobile-module__BcsPoG__mobileNavDropdown",
  "mobileNavTitle": "mobile-module__BcsPoG__mobileNavTitle",
});
